/**
 * @fileoverview Hook for starting and stopping a timer
 *
 * @example
 * // Usage:
 * import { useTimer } from './useTimer'
 *
 * function Component() {
 *   const [start, stop, timer] = useTimer()
 *   // ...
 * }
 */

import { useEffect, useState } from 'react'

/**
 * @function useTimer
 * @description Hook for starting and stopping a timer
 * @returns {[function, function, number]} An array containing the start, stop, and timer functions
 */
export function useTimer(): [() => void, () => void, number] {
    const [timer, updateTimer] = useState<number>(0)
    const [interval, setInterval] = useState<number>()
    const [isActive, setIsActive] = useState<boolean>(false)

    function start() {
        updateTimer(1 * 10e-10)
        setIsActive(true)
    }

    function stop() {
        setIsActive(false)
    }

    useEffect(() => {
        if (!isActive) {
            window.clearInterval(interval)
            return
        }

        setInterval(
            window.setInterval(() => {
                updateTimer((t) => t + 1)
            }, 1000)
        )

        return () => window.clearInterval(interval)
    }, [isActive])

    return [start, stop, timer]
}
